const APPS = [
    "Netflix",
    "Spotify",
    "YouTube Premium",
    "Disney+ Hotstar",
    "Canva",
    "ChatGPT Plus",
    "Viu",
    "Vidio",
    "Adobe",
    "Zoom",
];

const Dot = () => (
    <span className="mx-6 inline-block h-2.5 w-2.5 shrink-0 rounded-full bg-gradient-to-r from-brand-coral via-brand-violet to-brand-blue sm:mx-10" />
);

export default function Marquee() {
    return (
        <section className="relative -rotate-1 border-y border-white/10 bg-white/[0.02] py-7 sm:py-9" data-testid="marquee">
            <div className="flex overflow-hidden">
                <div className="animate-marquee flex w-max shrink-0 items-center pr-10">
                    {APPS.map((app, i) => (
                        <span key={i} className="flex items-center">
                            <span
                                className={`whitespace-nowrap font-display text-3xl font-extrabold tracking-tight sm:text-5xl ${
                                    i % 2 === 0 ? "text-white/90" : "text-outline"
                                }`}
                            >
                                {app}
                            </span>
                            <Dot />
                        </span>
                    ))}
                </div>
                <div aria-hidden="true" className="animate-marquee flex w-max shrink-0 items-center pr-10">
                    {APPS.map((app, i) => (
                        <span key={i} className="flex items-center">
                            <span
                                className={`whitespace-nowrap font-display text-3xl font-extrabold tracking-tight sm:text-5xl ${
                                    i % 2 === 0 ? "text-white/90" : "text-outline"
                                }`}
                            >
                                {app}
                            </span>
                            <Dot />
                        </span>
                    ))}
                </div>
            </div>
        </section>
    );
}
